export enum EtablissementProjection {
  DEFAULT = 'DEFAULT',
  TABLEAU_OFA = 'TABLEAU_OFA', // Parcours OFA - Mon OFA - Tableau
  TABLEAU_FC = 'TABLEAU_FC', // Parcours FC - Détails OFA - Tableau
  CARD = 'CARD', // Parcours OFA - Tableau de bord - Infos contenues dans les cards affichées dans l'étape 2 et 3 de l'étapier
  INFO = 'INFO',  // Parcours OFA/FC - Infos affichées dans le formulaire d'édition
  DECLARANT = 'DECLARANT', // Parcours OFA - Tableau de bord - Infos contenues dans l'étape 4 de l'étapier
  SUIVI_DEPOT = 'SUIVI_DEPOT', // Parcours OFA - Campagne - Tableau suivi dépôt
  IDENTITY = 'IDENTITY', // Parcours FC - Historique actions - Filtres
  SUIVI_DEPOT_SIRET = 'SUIVI_DEPOT_SIRET', // Parcours FC - Campagne - Suivi dépôt en vue SIRET
}